import { OutputParametricSelector } from 'reselect';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
import { Namespace, NamespaceProps, LoadingsState } from './types';

const selectLoadings = (state: AppState) => state.loading;
const selectNamespace = (state: AppState, props: NamespaceProps) =>
    props.namespace;

const selectIsLoading = createDeepEqualSelector(
    selectLoadings,
    (loadingsState) => Object.values(loadingsState).some((value) => value)
);

const makeSelectLoading = (
    namespace?: Namespace
): OutputParametricSelector<
    AppState,
    NamespaceProps,
    boolean,
    (
        arg1: ReturnType<typeof selectLoadings>,
        arg2: ReturnType<typeof selectNamespace>
    ) => boolean
> =>
    createDeepEqualSelector(
        [selectLoadings, selectNamespace],
        (loadingsState: LoadingsState, namespaceState) => {
            const namespaceValue = namespaceState || namespace;
            let result = false;

            if (!namespaceValue) return result;

            if (namespaceValue.constructor === Array) {
                result = namespaceValue.some((ns) => loadingsState[ns]);
            } else {
                result = !!loadingsState[namespaceValue as string];
            }

            return result;
        }
    );

export { selectIsLoading, makeSelectLoading };
